/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectActiveWorkspaces, selectLoadingWsForDropdown } from 'store/Workspace/selectors';
import SearchList from 'Common/Components/SearchList';
import { selectTriggerAgentWs } from 'store/Agents/selectors';
import { addTriggerAgentWs, removeTriggerAgentWs } from 'store/Agents/actions';
import { useIntl } from 'react-intl';
import {
  Wrapper, WrapperField, Label,
  WorkspaceList, Workspace, Name, TrashIcon
} from './styled';
import { getWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import useTheme from 'Hooks/UseTheme';
import get from 'lodash/get';

const WorkspaceSelector = ({ currentTool, onRemove, onSelect }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const loadingWorkspaces = useSelector(selectLoadingWsForDropdown);
  const addedWorkspaces = useSelector((state) => selectTriggerAgentWs(state, get(currentTool, 'id', 0)));
  const allWorkspaces = useSelector(selectActiveWorkspaces);
  const notAddedWorkspaces = addedWorkspaces
    ? allWorkspaces.filter(ws =>
      addedWorkspaces.every(added => ws.id !== added.id)
    )
    : allWorkspaces;
  const workspaceList = notAddedWorkspaces.map((ws) => ({ primary: ws.name, id: ws._id }));

  const isOdd = (workspaceNumber) => workspaceNumber % 2 !== 0;
  const { themeStyles } = useTheme();

  const label = intl.formatMessage({ id: 'agents.triggerAgent.wsSelector.label' });

  const onRemoveWs = (ws) => {
    onSelect && onRemove(ws);
    dispatch(removeTriggerAgentWs(ws, currentTool));
  };

  const onSelectWs = (ws) => {
    onRemove && onSelect(ws);
    dispatch(addTriggerAgentWs(ws.primary, currentTool));
  };

  useEffect(() => {
    dispatch(getWorkspaces(false, false));
  }, [dispatch]);

  if (!currentTool) return null;
  return (
    <Wrapper>
      <Label children={ label } />
      <WrapperField>
        <SearchList onSelect={ onSelectWs } items={ workspaceList } loadingData={ loadingWorkspaces } />
        { addedWorkspaces?.length > 0
          ? <WorkspaceList>
             {addedWorkspaces.map((ws, i) => (
                <Workspace key={ `Workspace_${ws}` } isOdd={ isOdd(i) } theme={ themeStyles }>
                  <Name>{ ws }</Name>
                  <TrashIcon onClick={ () => onRemoveWs(ws) } />
                </Workspace>
             ))}
            </WorkspaceList>
          : null
        }

      </WrapperField>
    </Wrapper>
  );
};

export default WorkspaceSelector;
